








import {
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { AccountFlagNames } from '@modules/userProfile/account/FeatureFlags';
import { getFederationComponent } from '@src/federations/getFederationComponent';

export default defineComponent({
    setup() {
        const isCouponCodeEnabled = ref(false);

        function getCouponCodeEnabled(): Promise<boolean> {
            return featureFlagService.getFeatureValue(AccountFlagNames.hasBonusCodeOnRegistration, false);
        }

        onMounted(async () => {
            isCouponCodeEnabled.value = await getCouponCodeEnabled();
        });

        return {
            isCouponCodeEnabled,
        };
    },
    components: {
        RegisterContainer: getFederationComponent(() => import('account/countries/rs/RegisterContainer')),
    },
});
